//interceptor for request and response 
import axios from 'axios';
const axiosHttp = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

axiosHttp.interceptors.request.use(
    (config) => {
        const token = process.env.REACT_APP_API_TOKEN
        return {
            ...config,
            headers: {
                ...(token !== null && { Authorization: `Bearer ${token}` }),
                ...config.headers,
                'Content-Type': 'application/json'
            },
        };
    },

    
    (error) => {
        return Promise.reject(error);
    }
);

axiosHttp.interceptors.response.use(
    (response) => {
        //const url = response.config.url;
        //setLocalStorageToken(token);
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            //(`unauthorized :)`);
            //localStorage.removeItem("persist:root");
            //removeLocalStorageToken
            //window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default axiosHttp;